/* eslint-disable no-param-reassign */
import React from "react";
import ReactDOM from "react-dom";

/**
 * HoC for adding open/close handles to any component.
 * .open(props) mounts + renders the component, if it's not mounted.
 * .close() removes the component from DOM.
 * @param {object} Component - the React Component to wrap.
 * @param {string} ELEMENT_ID - the ID of the DOM node at which to mount the component.
 * Creates DOM node within document.body if it doesn't exist.
 * @returns {object} React Component with open/close functions.
 */
function withModalController(Component, ELEMENT_ID) {
	const ModalControlled = (props) => <Component {...props} />;
	ModalControlled.open = (props) => {
		let root = document.getElementById(ELEMENT_ID);

		// Create the root if it doesn't exist.
		if (!root) {
			root = document.createElement("div");
			root.id = ELEMENT_ID;
			document.body.appendChild(root);
		}

		// Mount the component at the root.
		ReactDOM.render(<Component {...props} />, root);
	};
	ModalControlled.close = () => {
		const root = document.getElementById(ELEMENT_ID);

		// Exit if it doesn't exist.
		if (!root) {
			return;
		}

		// Wait for a frame.
		requestAnimationFrame(() => {
			// Unmount the component.
			ReactDOM.unmountComponentAtNode(root);

			// Cleanup after outselves.
			root.parentNode.removeChild(root);
		});
	};

	return ModalControlled;
}

export default withModalController;



// WEBPACK FOOTER //
// ./src/shared/hocs/withModalController.js